import { reactive } from 'vue';
import { getStorage, setStorage } from '../../utilities/nojq/_localstorage';
import $eventBus from '@/common/providers/eventbus';
const isSSR = typeof window === 'undefined';

export function useAttribute(initialData = []) {
    const state = reactive({
        attrFavList: [],
        attributes: [],
    });

    const toggleFavorite = (id) => {
        if (state.attrFavList.includes(id)) {
            removeFavorite(id);
        } else {
            addFavorite(id);
        }
    };

    const addFavorite = (id) => {
        if (state.attrFavList.includes(id)) {
            return;
        }
        if (state.attrFavList.length >= 20) {
            state.attrFavList.shift();
        }
        state.attrFavList.push(id);
        if(!isSSR) {
            setStorage('attrFavList', state.attrFavList);
        }
    };

    const removeFavorite = (id) => {
        state.attrFavList.splice(state.attrFavList.indexOf(id), 1);
        if(!isSSR) {
            setStorage('attrFavList', state.attrFavList);
        }
    };

    const convert = (data) => {
        const labelList = (!isSSR ? getStorage('attrFavList') : []) || [];

        if (data && data.length) {
            data.forEach((item) => {
                if (labelList.indexOf(item.attributeId) < 0) {
                    labelList.push(item.label);
                }
            });

            state.attributes = data.sort((x) => {
                return state.attrFavList.indexOf(x.attributeId) >= 0 ? -1 : 1;
            });
        }
    };

    $eventBus.$on('add-attribute-fav', (data) => {
        addFavorite(data.label);
    });
    $eventBus.$on('remove-attribute-fav', (data) => {
        removeFavorite(data.label);
    });

    convert(initialData);

    return {
        state,
        convert,
        toggleFavorite,
    };
}